<template>
    <sales-graph
        :data="data"
        :loading="loading"
        :error="error"
        :tooltip="$t('producerDashboard.salesGraphTooltip')"
        @redo="redo"
    >
        <template #filters>
            <v-flex shrink>
                <select-all
                    v-if="region !== 'PL'"
                    class-name="d-inline-block mr-3 mb-3 select--responsive"
                    v-model="campaign"
                    :items="campaignOptions"
                    :disabled="loading"
                    :label="$t('salesGraph.shop')"
                    :all-label="$t('salesGraph.allShops')"
                    require-selection
                    @blur="handleCampaignBlur"
                />
            </v-flex>
        </template>
    </sales-graph>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import SalesGraph from '../../graphs/SalesGraph.vue';
import campaignFilterMixin from '../../../mixins/campaignFilterMixin';
import SelectAll from '../../common/SelectAll.vue';
import eventBus from '../../../services/eventBus';

export default {
    name: 'dashboard-sales',
    components: {
        SelectAll,
        SalesGraph,
    },
    mixins: [
        campaignFilterMixin,
    ],
    props: {
        spaceId: {
            type: Number,
        },
        dateFilter: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            region: process.env.VUE_APP_REGION_MODE,
            data: null,
            error: null,
        };
    },
    computed: {
        ...mapState({
            loading: state => state.dashboard.loading.salesChart,
        }),
        ...mapGetters({
            getterDashboardSalesChart: 'dashboard/getDashboardSalesChart',
        }),
    },
    watch: {
        spaceId(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.getData();
            }
        },
        dateFilter(newValue, oldValue) {
            if (
                newValue.startDate !== oldValue.startDate
                || newValue.endDate !== oldValue.endDate
                || newValue.compareStartDate !== oldValue.compareStartDate
                || newValue.compareEndDate !== oldValue.compareEndDate
            ) {
                this.getData();
            }
        },
    },
    created() {
        this.setDefaultCampaign(['PL']);
        this.getData();
        eventBus.$on('resetFilters', this.reset);
    },
    beforeDestroy() {
        eventBus.$off('resetFilters', this.reset);
    },
    methods: {
        reset() {
            this.setDefaultCampaign(['PL']);
            this.getData();
        },
        emitFilterDefaultChange() {
            const isFilterDefault = this.isDefaultCampaign(['PL']);
            this.$emit('filterDefaultChange', isFilterDefault);
        },
        getData(force = false) {
            this.emitFilterDefaultChange();
            this.getSalesChart(force);
        },
        redo() {
            this.getData(true);
        },
        handleCampaignBlur() {
            this.getData();
        },
        async getSalesChart(force = false) {
            try {
                if (!this.spaceId) {
                    return;
                }

                const { startDate, endDate } = this.dateFilter;
                this.error = null;
                await this.fetchSalesChart({
                    force,
                    startDate,
                    endDate,
                    campaign: this.campaign,
                });
                this.data = this.getterDashboardSalesChart(startDate, endDate, this.campaign);
            } catch (e) {
                this.error = e.message;
                this.data = null;
            }
        },
        ...mapActions({
            fetchSalesChart: 'dashboard/fetchSalesChart',
        }),
    },
};
</script>

<style lang="scss" scoped>
</style>
